import React, { useContext, useEffect, useRef, useState } from "react";
import {
  BookCheck,
  CircleCheckBig,
  NotebookPen,
  ShieldCheck,
  Star,
  UserCheck,
  UserRound,
} from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import { LocateFixed, MapPin, Search } from "lucide-react";
import { Card, CardContent, CardFooter } from "../ui/card";
import NumberTicker from "../ui/number-ticker";
import { StarFilledIcon } from "@radix-ui/react-icons";
import { Link, useNavigate } from "react-router-dom";
// import download from "./.././../../assets/app_qr (1).png
// import qr from "./../../assets/app_qr.png";
// import download from "./../../assets/download_app.webp";
import download from "./../../assets/assets_task_01jwawamvpejk9ngjcqv45g6pg_1748417031_img_2 (1).png";
import { ApiContext } from "src/context/ApiContext.jsx";
import axios from "axios";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import cities from "indian-cities-json";
import { Select as AntdSelect } from "antd";

import sampleVideo1 from "./../../assets/istockphoto-1867682680-640_adpp_is.mp4";
import sampleVideo2 from "./../../assets/4170498-uhd_3840_2160_25fps.mp4";
import ExperienceShowcase from "../ExperienceShowCase";
import { motion, useAnimation } from "framer-motion";
import QRWithLogo from "./QRCode";
const Home = () => {
  const navigate = useNavigate();

  const [openLocation, setOpenLocation] = useState(false);

  const {
    categories,
    Banner,
    service,
    offers,
    PromotionalBanner,
    subcategory,
    fetchreview,
    subservice,
    setCity,
    getsubservice,
  } = useContext(ApiContext);
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [query, setQuery] = useState("");
  const handleSearch = (service) => {
    navigate(`/search?service=${service._id}`);
  };

  const handleSearchQuery = (service) => {
    navigate(`/search?query=${service}`);
  };

  const filteredReviews = fetchreview
    .filter((review) => review.rating >= 4 && review.status === "approved") // Step 1: Filter reviews
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Step 2: Sort by newest
    .slice(0, 10); // Step 3: Limit to 10 reviews

  const calculateDaysAgo = (dateString) => {
    const reviewDate = new Date(dateString);
    const currentDate = new Date();
    const timeDifference = currentDate - reviewDate; // Difference in milliseconds
    const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days
    return daysAgo === 0 ? "Today" : `${daysAgo} days ago`; // Handle case when it's today
  };

  const [users, setUsers] = useState([]);
  const [completedCount, setCompletedCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [usersRes, servicesRes] = await Promise.all([
          axios.get("https://wavetechservices.in/api/user/patners", {}),
          axios.get("https://wavetechservices.in/api/user/completed-bookings"),
        ]);

        setUsers(usersRes.data.partners);
        setCompletedCount(servicesRes.data.count);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [popsubservice, setPopSubservice] = useState([]);

  useEffect(() => {
    if (subservice.length > 0) {
      const shuffled = [...subservice].sort(() => 0.5 - Math.random()); // Clone array before sorting
      setPopSubservice(shuffled.slice(0, 3));
    }
  }, [subservice]);

  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleLocationSelect = (place) => {
    console.log("place : ", place);
    setSelectedLocation(place);
    setOpenLocation(false);
  };

  const handleCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        console.log("lat , lon : ", lat, lng);
        fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyAHFoepvVjrlMUctcC4wn_VRpOznZBzmhA`
        )
          .then((response) => response.json())
          .then((data) => {
            const city = data.results[0]?.formatted_address;
            setSelectedLocation({ label: city });
          });
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const cityOptions = cities.cities.map((city) => ({
    value: city.name, // Correctly map to value
    label: city.name, // Correctly map to label
  }));

  const [selectedCity, setSelectedCity] = useState(null);

  // Load stored city when component mounts
  useEffect(() => {
    const storedCity = sessionStorage.getItem("city");
    if (storedCity) {
      setSelectedCity(storedCity);
    }
  }, []);

  // Update session storage whenever selectedCity changes
  useEffect(() => {
    if (selectedCity) {
      sessionStorage.setItem("city", selectedCity);
    } else {
      sessionStorage.removeItem("city");
    }
    getsubservice();
  }, [selectedCity]);

  const handleCityChange = (value) => {
    setSelectedCity(value);
    console.log("Selected city:", value);
  };

  // const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const animationRef = useRef(null);
  const speed = 1; // Adjust speed (pixels per frame)

  console.log("categories : ", categories);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer || categories.length <= 5) return; // Don't scroll if few items

    let left = 0;
    const containerWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;

    const animate = () => {
      left += speed;

      // Reset position when scrolled all the way
      if (left >= containerWidth - clientWidth) {
        left = 0;
        // Immediately append clones at the end for seamless transition
        scrollContainer.scrollLeft = 0;
      }

      scrollContainer.scrollLeft = left;
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    // Pause on hover
    const handleMouseEnter = () => {
      cancelAnimationFrame(animationRef.current);
    };

    const handleMouseLeave = () => {
      animationRef.current = requestAnimationFrame(animate);
    };

    scrollContainer.addEventListener("mouseenter", handleMouseEnter);
    scrollContainer.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      cancelAnimationFrame(animationRef.current);
      scrollContainer.removeEventListener("mouseenter", handleMouseEnter);
      scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [categories]);

  return (
    <div className="z-10 pt-[69.6px] overflow-hidden bg-gray-50 shadow-xl bg-gradient-to-b from-[#FBFBFB] to-[#f0f2f5]">
      <div
        ref={scrollContainerRef}
        className="flex items-center py-4 px-4 overflow-x-auto scrollbar-hide whitespace-nowrap"
      >
        {/* <div 
          className="inline-flex flex-col items-center mt-2 mx-2 min-w-[80px] md:min-w-[100px] hover:bg-gray-100 rounded-lg cursor-pointer p-2 transition-all"
        >
          <img
            src="https://w2backend.s3.amazonaws.com/subservice/1747386230767_Tempo_Traveller_PI.png"
            alt="Tempo Traveller"
            className="size-10 rounded-full object-cover"
          />
          <h1 className="text-sm md:text-md leading-normal opacity-80 truncate w-full text-center"> 
            Tempo Traveller
          </h1>
        </div> */}
        {categories?.map((category) => (
          <div
            key={category._id}
            onClick={() =>
              navigate(`/search?category=${encodeURIComponent(category._id)}`)
            }
            className="inline-flex flex-col items-center mt-2 mx-2 min-w-[80px] md:min-w-[100px] hover:bg-gray-100 rounded-lg cursor-pointer p-2 transition-all"
          >
            <img
              src={`${category.icon}`}
              alt={category.name}
              className="size-10 rounded-full object-cover"
            />
            <h1 className="text-sm md:text-md leading-normal opacity-80 truncate w-full text-center">
              {category.name}
            </h1>
          </div>
        ))}
        {/* <div
        className="inline-flex flex-col items-center mt-2 mx-2 min-w-[80px] md:min-w-[100px] hover:bg-gray-100 rounded-lg cursor-pointer p-2 transition-all"
        >
          <img
            src="https://w2backend.s3.amazonaws.com/subservice/1747386230767_Tempo_Traveller_PI.png"
            alt="Tempo Traveller"
            className="size-10 rounded-full object-cover"
          />
          <h1 className="text-sm md:text-md leading-normal opacity-80 truncate w-full text-center">
            Tempo Traveller
          </h1>
        </div> */}
        {categories?.map((category) => (
          <div
            key={`clone-${category._id}`}
            onClick={() =>
              navigate(`/search?category=${encodeURIComponent(category._id)}`)
            }
            className="inline-flex flex-col items-center mt-2 mx-2 min-w-[80px] md:min-w-[100px] hover:bg-gray-100 rounded-lg cursor-pointer p-2 transition-all"
            aria-hidden="true"
          >
            <img
              src={`${category.icon}`}
              alt={category.name}
              className="size-10 rounded-full object-cover"
            />
            <h1 className="text-sm md:text-md leading-normal opacity-80 truncate w-full text-center">
              {category.name}
            </h1>
          </div>
        ))}
      </div>

      <div className="flex lg:justify-center px-[5vw]  lg:items-center lg:gap-10 gradient flex-col gap-5  lg:flex-row py-7">
        <div className="space-y-5 lg:w-[50%] w-[100%] order-2 lg:order-1">
          <h1 className="lg:text-4xl font-bold text-white text-2xl">
            {/* Your Home, Our Expertise: Quality Services at Your Doorstep! */}
            <p> Expert Care for Your Home — </p>
            Fast, Reliable, Right at Your Door.
          </h1>

          <div className="flex flex-col lg:flex-row w-full gap-3">
            {/* City Select */}
            <div className="w-full lg:w-1/2">
              <AntdSelect
                showSearch
                allowClear
                className="w-full h-10"
                placeholder="Select a city"
                options={cityOptions}
                value={selectedCity}
                onChange={handleCityChange}
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
              />
            </div>

            {/* Search Bar */}
            <div className="w-full lg:w-1/2">
              <div className="flex border border-gray-300 rounded-md p-2 h-10 bg-white items-center justify-between w-full">
                <input
                  type="text"
                  className="border-none outline-none rounded-md w-full"
                  placeholder="Search Services..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
                <Search
                  className="cursor-pointer w-6 h-6"
                  onClick={() => handleSearchQuery(query)}
                />
              </div>
            </div>
          </div>

          {/* <div className="flex items-center text-white gap-3">
            <h1 className="text-white text-lg">Popular Searches :</h1>
            {popsubservice.map((category) => (
              <span
                key={category._id}
                className="bg-gray-300 text-black p-1 rounded-2xl px-2 text-md hover:bg-gray-200 truncate"
              >
                {category.name}
              </span>
            ))}
          </div> */}

          <p className="text-white text-sm opacity-80">
            {/* Unlock a World of Convenience: Discover Trusted Services That Make
            Your Life Easier, Right at Your Fingertips */}
            Seamless Living Starts Here — Trusted Home Services at Your
            Fingertips.
          </p>
          <div className="flex gap-4 pb-4 lg:pb-0 flex-wrap ">
            <div className="flex w-40 gap-1 items-center ">
              <UserCheck className="text-white w-10 h-10" />
              <div className="flex flex-col">
                <h1 className="font-bold text-white">
                  <NumberTicker value={users.length} />+
                </h1>
                <p className="text-white opacity-80 text-sm ">
                  Verified Provider
                </p>
              </div>
            </div>
            <div className="flex w-40 gap-1 items-center">
              <ShieldCheck className="text-white w-10 h-10" />
              <div className="flex flex-col">
                <h1 className="font-bold text-white">
                  <NumberTicker value={3000+completedCount} />+
                </h1>
                <p className="text-white text-sm opacity-80 truncate">
                  Service Completed
                </p>
              </div>
            </div>
            <div className="flex w-40 gap-1 items-center">
              <Star className="text-white w-10 h-10" />
              <div className="flex flex-col">
                <h1 className="font-bold text-white">
                  <NumberTicker value={fetchreview.length} />
                </h1>
                <p className="text-white text-sm opacity-80 ">
                  Reviews Globally
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[50%] w-[100%] order-1 lg:order-2">
          <Carousel
            plugins={[
              Autoplay({
                delay: 3000,
              }),
            ]}
          >
            <CarouselContent>
              {Banner.map((banner) => {
                return (
                  <CarouselItem>
                    <img
                      src={`${banner.image}`}
                      alt=""
                      className="w-full h-full rounded-2xl"
                    />
                  </CarouselItem>
                );
              })}
            </CarouselContent>
          </Carousel>
        </div>
      </div>

      {/* <div className="bg-[#FBFBFB] py-5 overflow-hidden">
        <h1 className="text-center text-4xl mt-6 mb-2 font-bold">
          Explore<span className="text-gradient">Travel Services</span>
        </h1> 
              {subcategory
          .slice(0, 1)
          .map((category) => {
            const isExpanded = expandedCategory === "Tempo Traveller Booking";
            return (
              <div className="mt-5"> 
                <div className="px-[5vw] flex justify-between items-center">
                  <h1 className="text-2xl truncate font-bold">
                    <span className="text-gradient">Book Travel </span>
                  </h1>
                  <p
                    className="text-black font-bold cursor-pointer text-[12px] truncate"
                    onClick={() =>
                      setExpandedCategory(isExpanded ? null : "Tempo Traveller Booking")
                    }
                  >
                    {isExpanded ? "View Less" : "View More"}
                  </p>
                </div>

                <div className="overflow-hidden  lg:px-0 ">
                  <div
                    className={` flex justify-start items-start mt-4 rounded-md gap-3 overflow-y-scroll
                    ${
                      isExpanded
                        ? "flex flex-wrap justify-start items-start sm:mx-20 mx-2"
                        : "sm:mx-20 mx-2 flex overflow-x-auto no-scrollbar"
                    }
                    `}
                  >
                   
                        <Card className="p-2 ">
                          <div
                            className="w-[200px] overflow-hidden rounded-md"
                            onClick={() => navigate(`/travelbooking`)}
                          >
                            <img
                              src="https://w2backend.s3.amazonaws.com/subservice/1747389249383_Tempo_Traveller_PI%20(1).png"
                              alt=""
                              className="w-[200px] h-[200px] object-cover rounded-md hover:scale-110 duration-500 "
                              />
                          </div>
                          <p className="mt-2 truncate">
                            Tempo Traveller 
                            
                          </p> 
                        </Card>
                        <Card className="p-2 ">
                          <div
                            className="w-[200px] overflow-hidden rounded-md"
                            onClick={() => navigate(`/travelbooking`)}
                            >
                            <img
                              src="https://w2backend.s3.amazonaws.com/subservice/1747389249382_AdobeStock_179808627-1200x800.webp"
                              alt=""
                              className="w-[200px] h-[200px] object-cover rounded-md hover:scale-110 duration-500 "
                            />
                          </div>
                          <p className="mt-2 truncate">
                            Driver

                          </p> 
                        </Card>
                       
                  </div>
                </div>
              </div>
            );
          })}
        </div> */}

      {/* Services */}

      {/* <div className="bg-[#FBFBFB] py-5 overflow-hidden">
        <h1 className="text-center text-4xl mt-6 mb-2 font-bold">
          Explore<span className="text-gradient"> Services Categories</span>
        </h1> 

        {categories?.slice(0, Math.floor(categories.length / 2))?.map((category) => { 
            return (
              <div className="mt-5"
              key={`clone-${category._id}`}
              onClick={() =>
              navigate(`/search?category=${encodeURIComponent(category._id)}`)
            }
              >  

                <div className="overflow-hidden  lg:px-0 ">
                  <div
                    className={` flex justify-start items-start mt-4 rounded-md gap-3 overflow-y-scroll
                      flex-wrap sm:mx-20 mx-2
                      `}
                      > 
                        <Card className="p-2 ">
                          <div
                            className="w-[200px] overflow-hidden rounded-md" 
                          >
                            <img
                              src={`${category.icon}`}
                              alt=""
                              className="w-[200px] h-[200px] object-cover rounded-md hover:scale-110 duration-500 "
                            />
                          </div>
                          <p className="mt-2 truncate">
                            {category?.name?.length > 24 ? `${category?.name?.slice(0, 24)}...` : category.name}
                          </p> 
                        </Card> 
                  </div>
                </div>
              </div>
            );
          })}
      </div> */}

      <div className=" py-10 px-4 overflow-hidden">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">
              Explore{" "}
              <span className="text-transparent bg-clip-text text-gradient from-blue-500 to-purple-600">
                Services Categories
              </span>
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Discover our premium services tailored to your needs
            </p>
          </div>

          {/* Categories Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 gap-6">
            {categories
              ?.slice(0, parseInt(categories.length / 2))
              .map((category) => (
                <motion.div
                  key={category._id}
                  whileHover={{ y: -5 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() =>
                    navigate(
                      // `/search?category=${encodeURIComponent(category._id)}`
                      `/subcategory?id=${encodeURIComponent(category._id)}`
                    )
                  }
                  className="group cursor-pointer"
                >
                  <div className="relative overflow-hidden rounded-xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group-hover:border-blue-100">
                    {/* Image Container */}
                    <div className="relative aspect-square overflow-hidden">
                      <img
                        src={category.icon}
                        alt={category.name}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />
                      {/* Gradient Overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    </div>

                    {/* Category Name */}
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-800 text-center truncate">
                        {category.name}
                      </h3>
                      <div className="mt-2 h-1 w-0 mx-auto bg-gradient-to-r from-blue-400 to-purple-500 group-hover:w-full transition-all duration-300" />
                    </div>

                    {/* View Button (appears on hover) */}
                    {/* <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <button className="px-3 py-1 bg-white text-blue-600 text-xs rounded-full shadow-md hover:bg-blue-50 transition-colors">
                        View Services
                      </button>
                    </div> */}
                  </div>
                </motion.div>
              ))}
          </div>

          {/* View All Button */}
          {/* <div className="text-center mt-12">
      <button className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-medium rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-105">
        View All Categories
      </button>
    </div> */}
        </div>
      </div>

      <div className="w-[100%] px-[5vw] my-10" >
        <Carousel
          plugins={[
            Autoplay({
              delay: 3000,
            }),
          ]}
        >
          <CarouselContent>
            {offers.map((offer) => {
              return (
                <CarouselItem className="relative">
                  <div className="relative h-[250px]">
                    <img
                      src={`${offer.promotionalImage}`}
                      alt=""
                      className="w-full h-full absolute blur-sm object-cover"
                    />
                    <div className="absolute space-y-3 flex flex-col justify-center text-white  font-mono w-full h-full items-center ">
                      <p className="alfa-slab text-4xl">{offer.offerTitle}</p>

                      <p className="text-2xl">
                        Use Promo Code :{" "}
                        <span className="alfa-slab text-gradient">
                          {" "}
                          {offer.couponCode}{" "}
                        </span>
                        and Get{" "}
                        <span className="alfa-slab text-gradient">
                          {" "}
                          {offer.discount}% Off
                        </span>
                      </p>
                    </div>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </div>

      <ExperienceShowcase />
      <div className="bg-gradient-to-b from-[#FBFBFB] to-[#f0f2f5] py-10 px-4 overflow-hidden">
        <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 gap-6">
        {categories?.slice(parseInt(categories.length / 2)).map((category) => (
          <motion.div
            key={category._id}
            whileHover={{ y: -5 }}
            whileTap={{ scale: 0.95 }}
            onClick={() =>
              // navigate(`/search?category=${encodeURIComponent(category._id)}`)
              navigate( 
                      `/subcategory?id=${encodeURIComponent(category._id)}`
                    )
            }
            
            className="group cursor-pointer"
          >
            <div className="relative overflow-hidden rounded-xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group-hover:border-blue-100">
              {/* Image Container */}
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={category.icon}
                  alt={category.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>

              {/* Category Name */}
              <div className="p-4">
                <h3 className="font-semibold text-gray-800 text-center truncate">
                  {category.name}
                </h3>
                <div className="mt-2 h-1 w-0 mx-auto bg-gradient-to-r from-blue-400 to-purple-500 group-hover:w-full transition-all duration-300" />
              </div>

              {/* View Button (appears on hover) */}
              {/* <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <button className="px-3 py-1 bg-white text-blue-600 text-xs rounded-full shadow-md hover:bg-blue-50 transition-colors">
                  View Services
                </button>
              </div> */}
            </div>
          </motion.div>
        ))}
      </div>
      </div> 
      </div>
      {/* Services */}
      {/* {subcategory.slice(Math.floor(subcategory.length / 2)).map((category) => {
        const isExpanded = expandedCategory === category.name;
        return (
          <div className="mt-5"> 
            <div className="px-[5vw] flex justify-between items-center">
              <h1 className="text-2xl truncate font-bold">
                <span className="text-gradient">{category.name}</span>
              </h1>
              <p
                className="text-black font-bold cursor-pointer text-[12px] truncate"
                onClick={() =>
                  setExpandedCategory(isExpanded ? null : category.name)
                }
              >
                {isExpanded ? "View Less" : "View More"}
              </p>
            </div>

            <div className="overflow-hidden  lg:px-0 ">
              <div
                className={` flex justify-start items-start mt-4 rounded-md gap-3 overflow-y-scroll
                ${
                  isExpanded
                    ? "flex flex-wrap justify-start items-start sm:mx-20 mx-2"
                    : "sm:mx-20 mx-2 flex overflow-x-auto no-scrollbar"
                }
                `}
              >
                {category.services.map((serve) => {
                  return (
                    <Card className="p-2 ">
                      <div
                        className="w-[200px] overflow-hidden rounded-md"
                        onClick={() => handleSearch(serve)}
                      >
                        <img
                          src={`${serve.icon}`}
                          alt=""
                          className="w-[200px] h-[200px] object-cover rounded-md hover:scale-110 duration-500 "
                        />
                      </div>
                      <p className="mt-2 truncate">
                        {serve?.name?.length > 24 ? `${serve.name.slice(0, 24)}...` : serve.name}
                      </p> 
                    </Card>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })} */}

      <div className="bg-black my-10">
        <div className="py-10">
          <h1 className="text-3xl text-center  text-white ">
            How Wave <span className="text-gradient">works</span>
          </h1>
          <p className="text-center pb-7 text-gray-300">
            Each listing is designed to be clear and concise, providing
            customers
          </p>
          <div className="flex lg:justify-center lg:items-center gap-5 flex-col lg:flex-row">
            <div className="w-[350px] flex flex-col justify-center items-center space-y-2 text-center">
              <NotebookPen className="text-white h-8 w-8" />
              <h1 className="text-white text-xl font-semibold">
                1. Post a Service
              </h1>
              <p className="text-gray-300">
                After you post a job, our matching system identifies and alerts
                relevant Provider, who can then express interest in your job.
              </p>
            </div>
            <div className="w-[350px] flex flex-col justify-center items-center space-y-2 text-center">
              <BookCheck className="text-white h-8 w-8" />
              <h1 className="text-white text-xl font-semibold">
                2. Getting Booked & Job done
              </h1>
              <p className="text-gray-300">
                After you post a job, our matching system identifies and alerts
                relevant Provider, who can then express interest in your job.
              </p>
            </div>
            <div className="w-[350px] flex flex-col justify-center items-center space-y-2 text-center">
              <NotebookPen className="text-white h-8 w-8" />
              <h1 className="text-white text-xl font-semibold">
                3. Get Reviewd & Get Leads
              </h1>
              <p className="text-gray-300">
                After you post a job, our matching system identifies and alerts
                relevant Provider, who can then express interest in your job.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          <h1 className="text-3xl text-center ">
            Reviews from our <span className="text-gradient">Customers</span>
          </h1>
          <p className="text-center pb-7 text-gray-500">
            Each listing is designed to be clear and concise, providing
            customers
          </p>
          <div className="px-[5vw] ">
            <Carousel className="w-ful">
              <CarouselContent className="-ml-1">
                {filteredReviews.map((review, index) => (
                  <CarouselItem key={index} className="basis-80">
                    <div className="p-1 mb-10 ">
                      <Card>
                        <CardContent className="flex aspect-square items-center justify-start p-6 flex-col  h-[200px] w-full">
                          <span className="text-xl font-semibold"></span>
                          <p className="text-sm text-gray-500 my-3">
                            {review?.comment}
                          </p>
                          <p className="flex justify-start items-center gap-1">
                            Rating
                            {[...Array(review?.rating)].map((_, index) => (
                              <StarFilledIcon className="text-green-900" />
                            ))}
                          </p>
                        </CardContent>
                        <CardFooter>
                          <div className="flex justify-between items-center gap-10">
                            <div className="flex gap-2 items-center font-bold capitalize ">
                              <h1>{review?.user?.name}</h1>
                            </div>
                            <p className="text-gray-500 text-[10px] truncate">
                              {calculateDaysAgo(review?.createdAt)}
                            </p>
                          </div>
                        </CardFooter>
                      </Card>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious />
              <CarouselNext />
            </Carousel>
          </div>
        </div>
      </div>

      <div className="px-[5vw] my-10 flex justify-center items-center gap-20 flex-col lg:flex-row">
        <img src={download} alt="" className="w-80 h-96" />
        <div className="space-y-6">
          <h1 className="text-2xl font-bold">
            Get Things Done Easily. Download the Wave App Today!
          </h1>
          <p className="text-md text-gray-600">
            Book appointments, manage projects, and stay connected with service
            providers - all on the go!
          </p>
          <div>
            <div className="space-y-2">
              <span className="flex gap-3 text-md">
                <CircleCheckBig className="text-green-600" /> Easy booking and
                appointment scheduling
              </span>
              <span className="flex gap-3 text-md">
                <CircleCheckBig className="text-green-600" /> Secure online
                payments
              </span>
              <span className="flex gap-3 text-md">
                <CircleCheckBig className="text-green-600" /> Manage
                communication with service providers
              </span>
            </div>
          </div>
          {/* <div className="flex items-center">
            <div className="flex gap-5 items-center">
              <img
                src={qr}
                alt=""
                className="w-28 rounded-md border-4 border-gray-200"
              />
              <div>
                <p className="text-gray-500">Scan to Download</p>
                <h2 className="font-bold text-2xl">iOS & Android</h2>
              </div>
            </div>
          </div> */}
          <QRWithLogo />
        </div>
      </div>
    </div>
  );
};

export default Home;
